import styled from "styled-components";

interface Props {
  fontSize: string;
}

export const TextShadow = styled.span<Props>`
  font-size: ${(props) => props.fontSize};
  font-weight: bold;
  -webkit-text-shadow: 3px 3px 1px rgba(0, 0, 0, 0.75);
  -moz-text-shadow: 3px 3px 1px rgba(0, 0, 0, 0.75);
  text-shadow: 3px 3px 1px rgba(0, 0, 0, 0.75);
  margin: 0;
`;
